import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

//TODO: Move this to APP context
export const ContainedBackdrop = ({ open }) => {
  return (
    <Backdrop
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        color: theme => theme.palette.primary.main,
        position: 'absolute',
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
